// extracted by mini-css-extract-plugin
export default {"flex-column":"followers_flex-column__aBES8","main-container":"followers_main-container__8aXwg","flex-row":"followers_flex-row__pFmps","page-size":"followers_page-size__failt"};